import { ReactNode, forwardRef } from 'react'
import styled from 'styled-components'

const StyleActionItem = styled.a``
const ActionCallEmail = (
  props: {
    value?: string
    actionType: 'tel' | 'mailto'
    children?: ReactNode
    className?: string
  },
  ref: any
) => {
  return (
    <StyleActionItem
      href={`${props?.actionType}:${props?.value}`}
      className={props?.className}>
      {props?.children}
    </StyleActionItem>
  )
}

export default forwardRef(ActionCallEmail)
